import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import Referrals from "@/pages/Referrals";
import ReferralDetail from "@/pages/ReferralDetail";
import Customers from "@/pages/Customers";
import Growth from "@/pages/Growth";
import Import from "@/pages/Import";
import Users from "@/pages/Users";
import Profit from "@/pages/Profit";
import Transactions from "@/pages/Transactions";
import CustomerProfile from "@/pages/CustomerProfile";
import Settings from "@/pages/Settings";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Overview />} />
            <Route path="referrals" element={<Referrals />} />
            <Route path="referrals/:code" element={<ReferralDetail />} />
            <Route path="customers" element={<Customers />} />
            <Route path="customers/:id" element={<CustomerProfile />} />
            <Route path="transactions" element={<Transactions />} />
            <Route path="profit" element={<Profit />} />
            <Route path="growth" element={<Growth />} />
            <Route path="import" element={<Import />} />
            <Route path="users" element={<Users />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
